export default __webpack_public_path__ + "static/media/Rebel's Dagger.d2b18d6d.jpg";